const CardLoading = () => {
  return <p className="intel-loading">Loading…</p>;
};

const CardError = ({ message }) => {
  return <p className="intel-error">{message}</p>;
};

export { CardLoading, CardError };
